module.exports = __webpack_public_path__ + "static/media/order.c6ae4305.svg";